/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lifecycle status of a student booking.

For graded event exam sessions (oral exams) these values carry a precise,
easily-misread meaning — see ``api/docs/features/oral-exam-1n.md`` §Completion
semantics and ``oral_exams.state_machine.is_committed``:

* ``COMPLETED`` does **not** mean "passed" — it means a *committed, gradable
  exam session occurred*: the exam started for a student who was genuinely present
  (they saw the first question). Leaving early after that point is a graded
  incomplete, not a re-book.
* ``CANCELLED`` means *no gradable exam session happened* (no-show / never genuinely
  entered / withdrew before start) — the student may re-book.

The invariant the oral-exam services enforce: a booking is ``COMPLETED`` iff the
run is *committed*; a never-committed run is ``CANCELLED`` and re-bookable.
 */
export type BookingStatus = (typeof BookingStatus)[keyof typeof BookingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;
